import Autocomplete from 'react-autocomplete';
import React from 'react';
import formatMoney from '../../../../../utils/formatMoney';
import _ from 'lodash';


const menuStyle = {
    position: 'absolute',
    left: '0',
    top: '100%',
    maxHeight: '350px',
    overflow: 'auto',
    border: '1px solid #cccccc',
  };

  const inputProps = {
    className: 'form-control awesomplete pillSelct-input',
    name: 'colaborador',
  };

const ThirdStep = props => (
    <div className='fdvEquip-slides-item simpleSlide active'>

    {props.listaPedidosXCortesia!==undefined?props.listaPedidosXCortesia.concat(props.pedidosNuevos.length>0?['']:[])
      .map(entry =>
      <div className='card card-lg card-plain mb-3'>
        <h3 className='card-title'>N° Pedidos</h3>
        {entry!==''?(
          <p className='h5'>
             {
                props.listaPedidosXCortesiaPedido.filter(element => element.codFiveBono===entry).map(entry => {return entry.numPedidoVeh})
                .map(element => (
                  <pedido>
                    {element + ' '}
                  </pedido>
                ))
              }
          </p>
        ):(
          <p className='h5'>
             {
                props.pedidosNuevos
                .map(element => (
                  <pedido>
                    {element + ' '}
                  </pedido>
                ))
              }
          </p>
        )}
        <hr className='modalBleed' />
        <h4 className='h5 bold mt-4 mb-5' id='bonoTl'>Bono total {props.codMonedaBono === "DOL"? 'US$' : 'S/'}{props.getCliente(props.profroma,entry).totalMontoBonoProforma}</h4>
        <div className='tableWrapper'>
          <table className='table table-hover'>
            <thead className='table-head'>
              <tr>
                <th>Cant. Vales</th>
                <th />
                <th>Monto</th>
                <th />
                <th>Totales</th>
              </tr>
            </thead>
            <tbody>
            {
               props.getCliente(props.profroma,entry).bonoMonto.map((bono,id)=>(
                <tr>
                    <td>{bono.value}</td>
                    <td className='h6'>x</td>
                    <td>{formatMoney(bono.monto)}</td>
                    <td className='h6'>=</td>
                    <td align='right'>{props.codMonedaBono === "DOL"? 'US$' : 'S/'}{formatMoney(bono.value * bono.monto)}</td>
                  </tr>
                ))
            }
              <tr className='table-noHover'>
                <td className='bold' colSpan='5' align='right'>{props.codMonedaBono === "DOL"? 'US$' : 'S/'}{props.getCliente(props.profroma,entry).totalMontoBonoProforma}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    ):(
      <div className='card card-lg card-plain mb-3'>
        <h3 className='card-title'>N° Pedidos</h3>
        <p className='h5'>  {
              props.arrayAsignarBonos.map(element => (
                <pedido>
                  {element + ' '}
                </pedido>
              ))
            }</p>
        <hr className='modalBleed' />
        <h4 className='h5 bold mt-4 mb-5' id='bonoTl'>Bono total {props.codMonedaBono === "DOL"? 'US$' : 'S/'}{props.totalMontoBonoProforma}</h4>
        <div className='tableWrapper'>
          <table className='table table-hover'>
            <thead className='table-head'>
              <tr>
                <th>Cant. Vales</th>
                <th />
                <th>Monto</th>
                <th />
                <th>Totales</th>
              </tr>
            </thead>
            <tbody>
            {
               props.getCliente(props.profroma).bonoMonto.map((bono,id)=>(
                <tr>
                    <td>{bono.value}</td>
                    <td className='h6'>x</td>
                    <td>{formatMoney(bono.monto)}</td>
                    <td className='h6'>=</td>
                    <td align='right'>{props.codMonedaBono === "DOL"? 'US$' : 'S/'}{formatMoney(bono.value * bono.monto)}</td>
                  </tr>
                ))
            }
              <tr className='table-noHover'>
                <td className='bold' colSpan='5' align='right'>{props.codMonedaBono === "DOL"? 'US$' : 'S/'}{formatMoney(props.totalMontoBonoProforma)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )}

      <hr className='modalBleed' />
      <div className='form-group'>
        <div className='form-group'>
          <label className='labelInfo'>Observaciones</label>
          <textarea className='form-control' onChange={(e)=> props.onChangebonoObservaciones(e)} value={props.bonoObservaciones} /><span className='error'>Mensaje de error</span>
        </div>
      </div>
      <hr className='modalBleed' />
      <div className='form-group'>
        <div className='pillSelct'>
          <p className='labelInfo'>Notificar a un colaborador</p>
          <div className='pillSelct-field'>
          <div className='awesomplete'>
              <Autocomplete
                getItemValue={item => item.idUsuario.toString()}
                value={props.colaborador}
                items={props.colaboradores}
                renderItem={(item, isHighlighted) =>
                  <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                    {`${item.apellidos} ${item.nombre}`}
                  </div>
                }
                onChange={props.changeColaborador}
                menuStyle={menuStyle}
                inputProps={inputProps}
                wrapperStyle={{ display: 'block' }}
                onSelect={props.selectColaborador}
              />
            </div>
            <div className='pillSelct-pills'>
              {
                props.colaboradoresSeleccionados.map((colaborador, idColaborador) => (
                  <label key={idColaborador} className='pill pill-cyan pillSelct-pills-item' htmlFor='colaborador'>
                    {colaborador.nombres}
                    <button
                      className='pillSelct-delete'
                      onClick={() => props.removeColaborador(colaborador.id)}
                    ><i className='icon ion-close pill-close' />
                    </button>
                  </label>
                ))
              }
            </div>
          </div>
        </div>
      </div>
      <p>Para aplicar el bones debes tener autorización. La gestión de bonos será enviada para aprobación.</p>
      <div className='modal-actions'>
        <button className='btn btn-default' onClick={props.previousStep}>Anterior</button>
        <button className='btn btn-primary pull-right' onClick={(e) =>props.onClicRegistrarProforma(props.flagBonos,_.filter(props.pedidos, _.property(props.profroma))[0][props.profroma])} >Enviar solicitud</button>
      </div>
    </div>
  );

  export default ThirdStep;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Bonos/AgregarBonos/ThirdStep.js